'use client';

import { Layout } from '../../../components/layout/Layout';
import { CatalogPage } from '../../../components/pages/catalog-events/catalog';
import { Action, City, Page as PageType, Social } from '../../../models';
import { Contact } from '../../../models/contact';
import { FilterQuery, ISortFilter } from '../../../models/filters';
import { Category as ActionCategory } from '../../../models/action';
import { Category } from '../../../models/categories';

export function PageComponent({
  currentCity,
  eventsList,
  categories,
  sortTypes,
  startQuery,
  categoriesForHeader,
  categoriesForMicrodata,
  gorbiletRekomenduet,
  footerProps,
}: {
  currentCity: City;
  eventsList: { count: number; results: Action[]; next: string | null };
  categories: ActionCategory[];
  sortTypes: ISortFilter[];
  startQuery: FilterQuery;
  categoriesForHeader: Category[];
  categoriesForMicrodata: {
    count: number;
    next: string | null;
    total_event_average_rating: number;
    total_event_count: number;
    total_event_max_price_stat: number;
    total_event_max_rating_stat: number;
    total_event_min_price_stat: number;
    total_event_min_rating_stat: number;
    total_event_total_views_count_stat: number;
  };
  gorbiletRekomenduet: {
    actions: Action[];
  };
  footerProps: {
    pageList: { results: PageType[] };
    socials: { results: Social[] };
    socialsLinks: { results: Social[] };
    contactList: { results: Contact[] };
  };
}) {
  return (
    <Layout
      footerProps={footerProps}
      currentCity={currentCity}
      categoriesForHeader={categoriesForHeader}
    >
      <CatalogPage
        initialSeoCategory={null}
        productMicrodata={
          <div
            css={{ display: 'none' }}
            itemScope
            itemType='https://schema.org/Product'
          >
            <meta itemProp='name' content='Каталог' />
            <div
              itemType='https://schema.org/AggregateOffer'
              itemScope
              itemProp='offers'
            >
              <meta content={String(eventsList.count)} itemProp='offerCount' />
              <meta
                content={String(
                  categoriesForMicrodata.total_event_max_price_stat
                )}
                itemProp='highPrice'
              />
              <meta
                content={String(
                  categoriesForMicrodata.total_event_min_price_stat
                )}
                itemProp='lowPrice'
              />
              <meta content='RUB' itemProp='priceCurrency' />
            </div>
            {categoriesForMicrodata.total_event_average_rating > 0 && (
              <div
                itemType='https://schema.org/AggregateRating'
                itemScope
                itemProp='aggregateRating'
              >
                <meta
                  content={String(
                    categoriesForMicrodata.total_event_total_views_count_stat
                  )}
                  itemProp='reviewCount'
                />
                <meta
                  content={String(
                    categoriesForMicrodata.total_event_min_rating_stat
                  )}
                  itemProp='worstRating'
                />
                <meta
                  content={String(
                    categoriesForMicrodata.total_event_max_rating_stat
                  )}
                  itemProp='bestRating'
                />
                <meta
                  content={String(
                    categoriesForMicrodata.total_event_average_rating
                  )}
                  itemProp='ratingValue'
                />
              </div>
            )}
          </div>
        }
        currentCity={currentCity}
        eventsList={eventsList}
        sortTypes={sortTypes}
        categories={categories}
        gorbiletRekomenduet={gorbiletRekomenduet}
        startQuery={startQuery}
      />
    </Layout>
  );
}
